import { useApolloClient } from '@apollo/client';
import { ListItem, ListItemText } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useBooleanState } from 'react-use-object-state';
import { Entity } from '../../../../types';
import { EntityRawDataLegacy } from '../../../graphql/queries';
import RawDataProgress from './RawDataProgress';
import { RawDataEntity, RawDataItemsQueryResponse } from './types';

interface Props {
  entity: Entity;
  onChange: (selectedObject: string) => void;
}

const RawDataObjectsLoader = ({ entity, onChange }: Props) => {
  const client = useApolloClient();

  const loading = useBooleanState(false);
  const [objects, setObjects] = useState<RawDataEntity[]>([]);
  const [selectedObject, setSelectedObject] = useState<string | null>(null);

  function handleSelectObjectChange(selectedObject: string) {
    setSelectedObject(selectedObject);
    onChange(selectedObject);
  }

  useEffect(() => {
    const fetchRawDataObjects = async () => {
      loading.setTrue();

      const rawDataQueryResult = await client.query({
        context: {
          mute: true, // Don't show toast error, we'll handle the error
        },
        query: EntityRawDataLegacy,
        variables: {
          entityId: entity.properties._id,
          source:
            entity.properties._integrationInstanceId ||
            entity.properties._source ||
            'api',
        },
        fetchPolicy: 'network-only',
      });

      const entityRawDataLegacy = rawDataQueryResult.data
        .entityRawDataLegacy as RawDataItemsQueryResponse;
      if (!entityRawDataLegacy) {
        loading.setFalse();
        return;
      }

      const { payload: payloads } = entityRawDataLegacy;

      setObjects(payloads);
      if (payloads.length > 0) {
        handleSelectObjectChange(payloads[0].name);
      }
      loading.setFalse();
    };

    void fetchRawDataObjects();
  }, [
    entity.properties._id,
    entity.properties._integrationInstanceId,
    entity.properties._source,
  ]);

  if (loading.state) {
    return <RawDataProgress />;
  }

  if (objects.length === 0) {
    return (
      <ListItem>
        <ListItemText primary="--" />
      </ListItem>
    );
  }

  return (
    <>
      {objects.map((o) => (
        <ListItem
          key={o.name}
          button
          selected={selectedObject === o.name}
          onClick={() => handleSelectObjectChange(o.name)}
        >
          <ListItemText primary={o.name} />
        </ListItem>
      ))}
    </>
  );
};
export default RawDataObjectsLoader;
